import { useNavigate } from 'react-router-dom';
import Button from 'src/components/atoms/button/button';
import Table from 'src/components/atoms/table/table';
import { User } from 'src/models/user.model';
import { Icon } from '../../../atoms/icon';
import Badge from '../../../atoms/badge/badge';
import { EDIT_ANAGRAPHIC_PERMISSION, isAuthorizedToHandleCapability } from '../../../../utils/capability-utils';
import { useAppSelector } from '../../../../reducers';

type Props = {
  employee: User;
};

export const EmployeesTableCard = (props: Props) => {
  const { employee } = props;
  const navigate = useNavigate();
  const { user } = useAppSelector(state => state.authentication);

  return (
    <Table.Row>
      <Table.Cell>
        {employee?.anagraphic?.firstname || employee?.anagraphic?.lastname
          ? `${employee?.anagraphic?.firstname || ''} ${employee?.anagraphic?.lastname || ''}`
          : '-'}
      </Table.Cell>
      <Table.Cell>{employee.email}</Table.Cell>
      <Table.Cell>{employee.authority?.name}</Table.Cell>
      <Table.Cell>
        <Badge label={employee.active ? 'Attivo' : 'Non attivo'} color={employee.active ? 'success' : 'error'} />
      </Table.Cell>
      <Table.Cell>{!employee.anagraphic && <Badge label="Anagrafica vuota" color="error" />}</Table.Cell>
      <Table.Cell align="right">
        {user && isAuthorizedToHandleCapability(user, EDIT_ANAGRAPHIC_PERMISSION) && (
          <Button onClick={() => navigate(`/employee/${employee.id}`, { state: employee })}>
            <Icon content="arrowRight" />
          </Button>
        )}
      </Table.Cell>
    </Table.Row>
  );
};
